import React from 'react';

const FacebookDeletionStatus = () => {
  return (
    <div className='facebook-deletion-status'>
      <h1>Data Deletion Status</h1>
      <p>
        Your data has been successfully deleted, or no data was found to delete.
      </p>
      <p>If you have further concerns, please contact help desk.</p>
    </div>
  );
};
export default FacebookDeletionStatus;
